"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.config.title': 'Configuración de Entrenamiento',
    'trainer.config.basic': 'Configuración Básica',
    'trainer.config.model.name': 'Nombre del Modelo',
    'trainer.config.model.name.required': 'Nombre del Modelo *',
    'trainer.config.model.name.placeholder': 'Ingrese un nombre único para su modelo',
    'trainer.config.base.model': 'Modelo Base',
    'trainer.config.fine.tuning': 'Elegir método de entrenamiento',
    'trainer.config.fine_tuning.lora_extension': 'Extensión LoRA',
    'trainer.config.fine_tuning.fulltrain': 'Entrenamiento Completo',
    'trainer.config.advanced': 'Configuración Avanzada',
    'trainer.config.advanced.hide': 'Ocultar',
    'trainer.config.advanced.show': 'Mostrar',
    'trainer.config.epochs': 'Épocas',
    'trainer.config.epochs.help': 'Número de iteraciones de entrenamiento (recomendado: 10-50)',
    'trainer.config.learning.rate': 'Tasa de Aprendizaje',
    'trainer.config.learning.rate.help': 'Controla qué tan rápido aprende el modelo (recomendado: 0.001)',
    'trainer.config.batch.size': 'Tamaño del Lote',
    'trainer.config.batch.size.help': 'Número de muestras procesadas juntas',
    'trainer.config.validation.split': 'División de Validación',
    'trainer.config.validation.split.help': 'Porcentaje de datos utilizados para validación (0.2 = 20%)',
    'trainer.config.train': 'Iniciar Entrenamiento',
};
